<body>
    <div>
        <div class="center-container">
            <div class="content-area">
                <!-- Stepper - Sidebar -->
                <div class="sidebar">
                    <div *ngIf="!isEditMode" class="role-title">Create a new scenario</div>
                    <div *ngIf="isEditMode" class="role-title">Editing {{ scenario_name }}</div>
                    <app-stepper [isEditMode]="isEditMode" (changeStepperEvent)="changeStepper($event)"></app-stepper>
                </div>
                <!-- Form Elements-->
                <div class="container">
                    <div class="inner-container">
                        <form [formGroup]="step5Form" (ngSubmit)="next()" class="form5">
                            <div class="title" id="innercontainer">
                                <div class="tell-us-block">
                                    <span class="paraTell">Guidelines for roleplay</span>
                                </div>
                                <div class="inner-block">
                                    <div class="cust">
                                        <label class="labels">Rule/Guideline:</label>
                                    </div>
                                    <div formArrayName="guidelineRule">
                                        <div class="cust row-1"
                                            *ngFor="let objective of guidelineRule.controls; let i = index">
                                            <input class="input-box" type="text" [formControlName]="i"
                                                placeholder="Add new Guidelines Rule">
                                            <img class="jj-close" (click)="removeInput(i)"
                                                src="../../../../assets/images/JJ_Icon_Close.svg" alt="">
                                        </div>
                                    </div>
                                    <div class="checkbox-list">
                                        <button type="button" (click)="addInput()">Add New +</button>
                                    </div>
                                </div>
                            </div>

                            <div class="outerContainer" id="outerContainer">

                                <div class="top-block">
                                    <div class="cust row-1">
                                        <label class="labels" for="customerName">Scenario Name<span
                                                style="color:#F30617;margin:2px">*</span>:</label>
                                        <input style="width: 80%;
                                        height: 29px;
                                        margin-top: -4px;
                                        margin-bottom: -3px;
                                        background: #FFFFFF 0% 0% no-repeat padding-box;
                                        border: 1px solid #E9E9E9;
                                        border-radius: 8px;
                                        opacity: 1;
                                        padding-left: 5px;
                                        font-size: 12px;margin-left: 10px;" type="text" formControlName="customerName"
                                            id="customerName" placeholder="Enter Scenario name"
                                            (input)="ScenarioName($event)">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="cancel-button" (click)="goBackMain()">&times;</div>
            </div>

        </div>
        <div *ngIf="isPopupVisible" id="myPopup" class="popup">
            <div class="popup-content">
                <h1 style="color: green">
                    Congratulations!
                </h1>
                <p>You have successfully {{createUpdateText}} roleplay scenario!</p>
                <button id="closePopup" (click)="closePopup()">
                    Ok
                </button>
            </div>
        </div>
        <div class="footer-step1">
            <div class="secondary-button" (click)="goBack()" *ngIf="this.isScenarioVisible">
                <div>Previous</div>
            </div>
            <div class="secondary-button" (click)="goBackScenario()" *ngIf="!this.isScenarioVisible">
                <div>Previous</div>
            </div>
            <div *ngIf="isNextVisible">
                <div class="primary-button" id="nextButton" (click)="summary()" *ngIf="ScenarioS">
                    <div>Next</div>
                </div>
            </div>
            <div class="primary-button" id="scenarioName" (click)="enterScenario()" *ngIf="this.isScenarioVisible">
                <div>Next</div>
            </div>
        </div>
    </div>
</body>